"use client";

import React from "react";
import Link from "next/link";

const SameDayEmergencyExtractions: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          Same-Day Emergency Tooth Extractions in Astoria
        </h2>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          A severely damaged or infected tooth can&apos;t always wait. If
          you&apos;re dealing with intense tooth pain, a broken tooth, or a
          dental abscess, prompt treatment is critical to prevent the infection
          from spreading to neighboring teeth or the jaw. Smile4Me offers
          same-day emergency tooth extractions when the situation calls for
          it.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Contact us as early in the day as possible if you&apos;re in pain;
          our team will do everything we can to get you seen quickly. As an{" "}
          <Link
            href="/services/emergency-treatment/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
          >
            emergency dentist in Astoria
          </Link>
          , Dr. Khaimov is experienced in managing urgent extractions
          efficiently and with care, so you spend less time in pain and more
          time on the path to recovery.
        </p>
      </div>
    </section>
  );
};

export default SameDayEmergencyExtractions;
